import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {ApiResponse, ApiRequest} from "@gongt/ts-stl-library/request/protocol";

export const VerifyImageUrl = `/verify_code.png`;
export const GetVerifyUrl = `/get_verify_code`;
export const VerifyImageMethod = ERequestType.TYPE_GET;
export const GetVerifyMethod = ERequestType.TYPE_GET;

export interface GetVerifyRequest extends ApiRequest {
	id: string;
}
export interface VerifyImageRequest extends ApiRequest {
	uid: string;
	hash: string;
}

export interface GetVerifyResponse extends ApiResponse {
	id: string;
}
